import { StatusDefinition, allowedStatuses } from './Status'

export interface SimplePaymentRetrieve {
    id: string
    status: string
    wallexRef: string
    failureReason: string
    paymentChannel: string
}

export interface SimplePaymentUpdatePayload {
    status: string
    failureReason?: string
}

export interface SimplePaymentStatus extends StatusDefinition {
    needReason: boolean
}

export default class SimplePayment {
    static journey = ['awaiting_funds', 'under_review', 'processing', 'in_transit', 'completed']

    static hints: Record<string, string> = {
        awaiting_funds: 'Waiting for the payment to be funded',
        under_review: 'Being checked before it is processed',
        processing: 'Being processed by the payment provider',
        in_transit: 'Sent, on its way to the beneficiary',
        completed: 'Delivered to the beneficiary',
        rejected: 'Stopped before it was sent',
        failed: 'Sent but could not be delivered',
    }

    static statuses(simplePayment: SimplePaymentRetrieve): SimplePaymentStatus[] {
        const statuses: Array<SimplePaymentStatus> = [
            {
                value: 'awaiting_funds',
                description: 'Awaiting Funds',
                needReason: false,
                available: [],
            },
            {
                value: 'under_review',
                description: 'Under Review',
                needReason: false,
                available: ['awaiting_funds'],
            },
            {
                value: 'processing',
                description: 'Processing',
                needReason: false,
                available: ['under_review'],
            },
            {
                value: 'in_transit',
                description: 'In Transit',
                needReason: false,
                available: ['processing'],
            },
            {
                value: 'completed',
                description: 'Completed',
                needReason: false,
                available: ['in_transit'],
            },
            {
                value: 'rejected',
                description: 'Rejected',
                needReason: true,
                available: ['awaiting_funds', 'under_review', 'processing'],
            },
            {
                value: 'failed',
                description: 'Failed',
                needReason: true,
                available: ['in_transit', 'completed'],
            },
        ]

        const disabledStatusesForInternal = ['processing', 'in_transit', 'completed', 'rejected']
        const isInternalWithRestrictedStatus = simplePayment.paymentChannel === 'INTERNAL' && simplePayment.status === 'under_review'

        return allowedStatuses(statuses, simplePayment.status).filter((status) =>
            isInternalWithRestrictedStatus ? !disabledStatusesForInternal.includes(status.value) : true
        )
    }
}
